const styles = theme => ({
  knowledgeBase: {
    maxWidth: '360px',
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '0px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
    },
  },
  knowledgeSection: {
    marginBottom: '32px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.20), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    borderRadius: '16px',
    padding: '16px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 500,
    marginBottom: '16px',
  },
  linkItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    textDecoration: 'none',
    borderRadius: '8px',
    color: 'inherit',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  linkText: {
    fontSize: '14px',
    fontWeight: 400,
    marginLeft: '16px',
  },
  moreResourcesButton: {
    color: '#1976d2',
    fontSize: '14px',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {},
  },
  feedbackBox: {
    display: 'flex',
    alignItems: 'center',
  },
  feedbackIcon: {
    backgroundColor: '#F5F5F5',
    borderRadius: '8px',
    padding: '8px',
  },
  icon: {
    width: '24px',
    height: '24px',
  },
  feedbackText: {
    fontSize: '14px',
    marginLeft: '12px',
    color: '#1a1a1a',
  },
  letUsKnowButton: {
    color: '#1976d2',
    fontSize: '14px',
    cursor: 'pointer',
    textDecoration: 'none',
    marginTop: '8px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  socialLink: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      textDecoration: 'none',
    },
  },
})

export default styles
